'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Hero = require('../sprites/Hero');

var _Hero2 = _interopRequireDefault(_Hero);

var _Spike = require('../sprites/Spike');

var _Spike2 = _interopRequireDefault(_Spike);

var _Enemy = require('../sprites/Enemy');

var _Enemy2 = _interopRequireDefault(_Enemy);

var _Block = require('../sprites/Block');

var _Block2 = _interopRequireDefault(_Block);

var _Fireball = require('../sprites/Fireball');

var _Fireball2 = _interopRequireDefault(_Fireball);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SpriteState = function () {
  function SpriteState() {
    _classCallCheck(this, SpriteState);
  }

  _createClass(SpriteState, [{
    key: 'spawnCharacters',
    value: function spawnCharacters(data) {
      // spawn enemies
      data.enemies.forEach(function (enemy) {
        var sprite = new _Enemy2.default(this.game, enemy.x, enemy.y, enemy.image, enemy.gravity);
        this.enemies.add(sprite);
      }, this);
      // spawn hero
      this.hero = new _Hero2.default(this.game, data.hero.x, data.hero.y);
      this.game.add.existing(this.hero);
    }
  }, {
    key: 'spawnPlatform',
    value: function spawnPlatform(platform) {
      var sprite = this.platforms.create(platform.x, platform.y, platform.image);
      // physics for platform sprites
      this.game.physics.enable(sprite);
      sprite.body.allowGravity = false;
      sprite.body.immovable = true;
      // spawn invisible walls at each side, only detectable by enemies
      this.spawnEnemyWall(platform.x, platform.y, 'left');
      this.spawnEnemyWall(platform.x + sprite.width, platform.y, 'right');
    }
  }, {
    key: 'spawnMovingBlocks',
    value: function spawnMovingBlocks(block) {
      var sprite = new _Block2.default(this.game, block.x, block.y);
      this.movingBlocks.add(sprite);
    }
  }, {
    key: 'spawnLava',
    value: function spawnLava(lava) {
      var sprite = this.lava.create(lava.x, lava.y, lava.image);
      this.game.physics.enable(sprite);
      sprite.body.allowGravity = false;
      sprite.body.immovable = true;
      // animations
      sprite.animations.add('flow', [0, 1, 2], 6, true);
      sprite.animations.play('flow');
    }
  }, {
    key: 'spawnFireball',
    value: function spawnFireball(data) {
      data.fireball.forEach(function (ball) {
        var sprite = new _Fireball2.default(this.game, ball.x, ball.y, ball.height, ball.velocity);
        this.fireball.add(sprite);
      }, this);
    }
  }, {
    key: 'spawnSpike',
    value: function spawnSpike(data) {
      data.spike.forEach(function (s) {
        var sprite = new _Spike2.default(this.game, s.x, s.y, s.image);
        this.spike.add(sprite);
      }, this);
    }
  }, {
    key: 'spawnEnemyWall',
    value: function spawnEnemyWall(x, y, side) {
      var sprite = this.enemyWalls.create(x, y, 'invisible-wall');
      // anchor and y displacement
      sprite.anchor.set(side === 'left' ? 1 : 0, 1);
      this.game.physics.enable(sprite);
      sprite.body.immovable = true;
      sprite.body.allowGravity = false;
    }
  }, {
    key: 'spawnRings',
    value: function spawnRings(ring) {
      var sprite = this.rings.create(ring.x, ring.y, 'ring');
      sprite.anchor.set(0.5, 0.5);
      this.game.physics.enable(sprite);
      sprite.body.allowGravity = false;
      // animations
      sprite.animations.add('rotate', [0, 1, 2, 1], 6, true);
      sprite.animations.play('rotate');
    }
  }, {
    key: 'spawnFinish',
    value: function spawnFinish(data) {
      var sprite = this.finish.create(data.finish.x, data.finish.y, 'finish');
      this.game.physics.enable(sprite);
      sprite.anchor.setTo(0.5, 1);
      sprite.body.allowGravity = false;
      sprite.animations.add('open', [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]);
    }
  }, {
    key: 'spawnSpring',
    value: function spawnSpring(spring) {
      var sprite = this.spring.create(spring.x, spring.y, 'spring');
      this.game.physics.enable(sprite);
      sprite.body.allowGravity = false;
      sprite.animations.add('jump', [0, 1, 0], 12);
    }
  }]);

  return SpriteState;
}();

exports.default = SpriteState;


//////////////////
// WEBPACK FOOTER
// ./src/states/SpriteState.js
// module id = 338
// module chunks = 0